// Сурлага хөгжлийн үйл явц — хичээл бүрийн сүүлийн үнэлгээ (СҮД код, 1–4), багшийн тайлбар, энэ улирлын өмнөх үнэлгээ (LMS-ээс).
import React, { useEffect, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { instance } from "utils/axios";

const ABBR = (s) => String(s || "?").split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
const TONES = ["#f3eeff", "#e0f7fa", "#fff6d6", "#e7f6ec", "#fde8e8", "#e0f2fe", "#f3eeff"];
export const LEVEL4 = ["", "Танилцаж байна", "Хөгжиж байна", "Бие даан эзэмшсэн", "Илүү өргөн хэрэглэж байна"];
export const Dots = ({ v }) => (
  <span className="inline-flex gap-1" aria-label={`${v}/4`}>{[1, 2, 3, 4].map((i) => <span key={i} className={`h-2 w-4 rounded-full ${i <= v ? "bg-primary" : "bg-[#e5d8f5]"}`} />)}</span>
);

export default function Subjects({ childId }) {
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    let alive = true;
    instance({ method: "get", url: `/student/elem/${childId}/subjects` }).then((r) => alive && setList(r.data.subjects)).catch(() => alive && setList([]));
    return () => { alive = false; };
  }, [childId]);
  if (!list || !list.length) return null;
  return (
    <section aria-labelledby="subj-h" className="tj-card px-4 pt-[18px] pb-2 md:px-6 md:pt-6">
      <div className="flex flex-wrap items-end justify-between gap-2 mb-2">
        <div>
          <h2 id="subj-h" className="m-0 text-xl md:text-[22px] font-bold">Сурлага хөгжлийн үйл явц</h2>
          <div className="text-sm text-[#6e5e8a]">Хичээл бүрийн сүүлийн үнэлгээ, багшийн тайлбар</div>
        </div>
        <div className="text-xs text-[#6e5e8a]">{LEVEL4.slice(1).map((l, i) => <span key={l} className="mr-2"><b className="text-primary">{i + 1}</b> {l}</span>)}</div>
      </div>
      {list.map((s, i) => {
        const on = open === s.courseId;
        return (
          <div key={s.courseId} className="border-t border-[#efedf4]">
            <button type="button" onClick={() => setOpen(on ? null : s.courseId)} aria-expanded={on} className="w-full flex items-center gap-3 py-3.5 text-left">
              <span className="h-10 w-10 rounded-xl flex items-center justify-center text-sm font-extrabold text-primary shrink-0" style={{ background: TONES[i % TONES.length] }}>{ABBR(s.subject)}</span>
              <span className="flex-1 min-w-0">
                <span className="block text-[15px] font-bold">{s.subject}</span>
                <span className="block text-[13px] text-[#6e5e8a] truncate"><b className="text-primary">{s.latest.code}</b> {s.latest.text}</span>
              </span>
              <Dots v={s.latest.level} />
              <span className="w-5 text-right font-extrabold">{s.latest.level}</span>
              <FiChevronDown className={`text-primary transition-transform ${on ? "rotate-180" : ""}`} />
            </button>
            {on && (
              <div className="pb-4 pl-[52px] flex flex-col gap-3">
                {s.comment && <div className="rounded-xl bg-[#faf7ff] border border-[#e5d8f5] p-3"><div className="text-[13px] font-bold text-primary">Багшийн тайлбар{s.comment.teacher ? ` · ${s.comment.teacher}` : ""}</div><p className="m-0 text-sm">{s.comment.text}</p></div>}
                {s.history.length > 0 && (
                  <div>
                    <div className="text-[13px] font-bold text-[#6e5e8a] mb-1">Энэ улирлын өмнөх үнэлгээ</div>
                    {s.history.map((h, j) => <div key={j} className="flex justify-between text-sm py-1 border-b border-[#f3f1f7]"><span><b className="text-primary">{h.code}</b> {h.criterion || h.text}</span><b>{h.level}</b></div>)}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </section>
  );
}
